import { withStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useCallback } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Helmet from 'react-helmet';
import { RECAPTCHA_KEY } from '../../configurations';
import { compose } from '../../utility';
import { messages } from '../constants';
import styles from './styles';
import Button from '../../shared/button/button';
import { EVENT_KEYS } from '../../constants';
import SignatureIdInput from './idInput';
import CertificateDetail from '../signature-certificate/SignatureCertificate';
import SignatureLayout from '../layout/layout';

const SignatureValidation = ({ classes, history, match }) => {
  const [signatureID, setSignatureID] = useState('');
  const [captured, setCaptured] = useState(false);
  const [isCertificated, setIsCertificated] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (match.params.sId) {
      setSignatureID(match.params.sId);
    }
  }, [match.params.sId]);

  useEffect(() => {
    if (isCertificated && history.action === 'POP') {
      setIsCertificated(false);
      setErrorMessage('');
    }
  }, [history.action, isCertificated]);

  const handleLookUp = useCallback(() => {
    setIsCertificated(true);
    setErrorMessage('');
    history.push(`/s/${signatureID}`);
  }, [signatureID, history]);

  const canLookUp = () => signatureID && captured;

  const handleSubmit = (ev) => {
    if (ev.key === EVENT_KEYS.ENTER && canLookUp()) {
      handleLookUp();
    }
  };

  const validateSignatureID = (str) => {
    const validateREGX = /^[A-Za-z0-9]{4}[-]{1}[A-Za-z0-9]{4}$/;
    return validateREGX.test(str);
  };

  const verifyRecaptchaCallback = () => {
    setCaptured(true);
  };

  const handleCertificateError = (error = messages.WRONG_CERTIFICATE_ERROR) => {
    setErrorMessage(error);
    setIsCertificated(false);
  };

  if (isCertificated) {
    return (
      <SignatureLayout>
        <div className={classes.root}>
          <div className={classes.screenContainer}>
            <CertificateDetail
              match={match}
              stampHash={signatureID}
              handleCertificateError={handleCertificateError}
              backToLayout={() => setIsCertificated(false)}
            />
          </div>
        </div>
      </SignatureLayout>
    );
  }

  return (
    <SignatureLayout>
      <div className={classes.root}>
        <Helmet
          titleTemplate="%s - RealDesk Esign"
          defaultTitle="RealDesk Esign"
        >
          <meta name="description" content="Signature Validation" />
          <title>Signature Validation</title>
        </Helmet>
        <div className={classes.screenTitle}>Signature Validation System</div>
        <div
          className={classes.screenContainer}
          onKeyPress={(ev) => handleSubmit(ev)}
          role="button"
          tabIndex="0"
        >
          <SignatureIdInput
            defaultSignatureID={match.params.sId}
            setSignatureID={setSignatureID}
          />

          <ReCAPTCHA
            sitekey={RECAPTCHA_KEY}
            onChange={verifyRecaptchaCallback}
            onExpired={() => setCaptured(false)}
          />

          <Button
            testId="button-submit"
            color="primary"
            classes={{ button: classes.submitButton }}
            text="Look Up"
            onClick={handleLookUp}
            disabled={!canLookUp()}
          />
          <p className={classes.errorMessage}>{errorMessage}</p>
        </div>
      </div>
    </SignatureLayout>
  );
};

export default compose(withStyles(styles, { withTheme: true }))(
  SignatureValidation
);
